import { Component, Input, OnInit } from "@angular/core";
import { PropertyOptions } from "../../../services/property-features.service";
import { PropertyService } from "../../../services/property.services";

@Component({
  selector: "app-property-features-br",
  templateUrl: "./property-features-br.component.html",
  styleUrls: ["./property-features-br.component.scss"]
})
export class PropertyFeaturesBrComponent implements OnInit {
  @Input() property: any;
  @Input() isMultifamily;
  @Input() customPropertyFeatures: PropertyOptions[] = [];
  listFeatures: any = [];
  featureOptions: any = [];
  featureOptionsMap: any = {
    8: {
      icon: "assets/featuresIcons/ac_unit.svg",
      label: "detail.centralAirConditioning"
    },
    7: {
      icon: "assets/featuresIcons/ac_unit.svg",
      label: "detail.WindowAirCondition"
    }
  };

  constructor(private propertyService: PropertyService) {}

  ngOnInit(): void {
    setTimeout(() => {
      let features = document.getElementById("features");
      this.listFeatures = features?.getElementsByTagName("div");

      this.propertyService
        .getPropertiesFeature(this.property.id)
        .then((resp: any[]) => {
          const activeFeatures = resp.filter(f => f.active);

          this.featureOptions = activeFeatures.flatMap(f =>
            f.selectedOptions
              .filter(optId => this.featureOptionsMap[optId])
              .map(optId => this.featureOptionsMap[optId])
          );
        });
    }, 1000);
  }
}
